export default {
	color: 'darkslategray',
	message: 'this is only used by the main-a.js entry point, so will be bundled with it'
};